export function getMemberships (state) {
	return state.memberships;
}
